import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="mapping-list-upload"
export default class extends Controller {
  private errorsTarget!: HTMLElement
  private chevronTarget!: HTMLElement

  static targets = ['errors', 'chevron']

  toggle(): void {
    this.errorsTarget.classList.toggle('tw-hidden')
    this.chevronTarget.classList.toggle('fa-chevron-right')
    this.chevronTarget.classList.toggle('fa-chevron-down')
  }
}
